var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 22.5,
    viewBox: "0 0 22.5 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6985",
    "data-name": "Group 6985",
    transform: "translate(-53.899 -1374.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6896",
    "data-name": "Group 6896",
    transform: "translate(54 1375)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1013",
    "data-name": "Ellipse 1013",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(0.149 0.149)",
    fill: "#fff",
    stroke: "#e7873c",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6984",
    "data-name": "Group 6984",
    transform: "translate(59.567 1379.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16064",
    "data-name": "Path 16064",
    d: "M16.168,45.44a.287.287,0,0,1-.108-.256q0-4.447,0-8.892a.593.593,0,0,1,.006-.106.162.162,0,0,1,.172-.146.158.158,0,0,1,.168.149,1.063,1.063,0,0,1,.005.153v8.451l.044.028a1.2,1.2,0,0,1,.093-.132q2.156-2.228,4.312-4.454c.216-.223.309-.234.574-.07L23.929,41.7l.116.068.864-1.024.411-.488c.09-.107.19-.127.276-.056s.088.171,0,.28q-.637.76-1.279,1.517a.318.318,0,0,1-.47.064q-1.281-.788-2.561-1.579c-.076-.047-.119-.052-.187.018q-2.186,2.264-4.377,4.522c-.014.014-.026.028-.059.066H27.03c.031,0,.063,0,.094,0,.1,0,.194,0,.238.11s-.016.178-.09.243Z",
    transform: "translate(-16.06 -33.344)",
    fill: "#ae2b30",
    stroke: "#ae2b30",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16065",
    "data-name": "Path 16065",
    d: "M44.976,13.553a3.26,3.26,0,0,1-2.821,3.2,3.2,3.2,0,0,1-3.605-2.766A3.123,3.123,0,0,1,39.7,11.073c.1-.09.2-.1.274-.026s.073.2-.043.292a2.9,2.9,0,0,0-.815,1.069,2.87,2.87,0,1,0,1.56-1.506c-.089.036-.175.053-.249-.028a.178.178,0,0,1,.093-.291,3.173,3.173,0,0,1,1.408-.235,3.208,3.208,0,0,1,2.928,2.427C44.915,13.028,44.936,13.294,44.976,13.553Z",
    transform: "translate(-36.164 -10.341)",
    fill: "#ae2b30",
    stroke: "#ae2b30",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16066",
    "data-name": "Path 16066",
    d: "M106,56.448l-.364.429c-.155.184-.308.367-.464.55-.091.107-.191.124-.275.052s-.084-.171.006-.28l.813-.966c.024-.028.046-.059.085-.108l-.759.061c-.169.014-.337.029-.506.039-.13.007-.211-.057-.217-.163a.181.181,0,0,1,.187-.187q.834-.071,1.669-.133a.165.165,0,0,1,.2.18c0,.586,0,1.172,0,1.758a.175.175,0,1,1-.348-.006c0-.366,0-.731,0-1.1v-.124A.072.072,0,0,1,106,56.448Z",
    transform: "translate(-95.059 -50.979)",
    fill: "#ae2b30",
    stroke: "#ae2b30",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6907",
    "data-name": "Group 6907",
    transform: "translate(4.236 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16067",
    "data-name": "Path 16067",
    d: "M56.688,22.89h2.449V22.9a3.962,3.962,0,0,1-.244.357h-.655a.856.856,0,0,1,.184.385h.7c.008,0,.013.005.013.01-.156.234-.236.351-.239.351h-.453a1.048,1.048,0,0,1-.173.435,1.078,1.078,0,0,1-.4.334,1.588,1.588,0,0,1-.683.171v.005q0,.025,1.474,1.75h-.648q-1.437-1.676-1.436-1.683v-.339l.005-.013a2.239,2.239,0,0,0,.3.018q.8,0,1-.522a.434.434,0,0,0,.03-.158H56.45a.009.009,0,0,1-.01-.01c.162-.233.244-.35.248-.35h1.156v-.005a.679.679,0,0,0-.385-.314,1.2,1.2,0,0,0-.367-.066h-.647v-.013C56.6,23.006,56.682,22.89,56.688,22.89Z",
    transform: "translate(-56.44 -22.89)",
    fill: "#ae2b30"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.42dfa23db9a62bbbf4df5c81e09fef68.svg";
export { ForwardRef as ReactComponent };